import card_001 from "./001.png";
import card_002 from "./002.png";
import card_003 from "./003.png";
import card_004 from "./004.png";
import card_005 from "./005.jpg";
import card_006 from "./006.jpg";
import card_007 from "./007.jpg";
import card_008 from "./008.jpg";
import card_009 from "./009.jpg";
import card_010 from "./010.jpg";
import card_012 from "./012.jpg";
import card_013 from "./013.jpg";
import card_014 from "./014.jpg";
import card_015 from "./015.jpg";
import card_016 from "./016.jpg";
import card_017 from "./017.jpg";
import card_018 from "./018.jpg";
import card_019 from "./019.jpg";
import card_020 from "./020.jpg";
import card_021 from "./021.jpg";
import card_022 from "./022.jpg";
import card_023 from "./023.jpg";
import card_024 from "./024.jpg";
import card_025 from "./025.jpg";
import card_026 from "./026.jpg";
import card_027 from "./027.jpg";

const cards = {
  card_001,
  card_002,
  card_003,
  card_004,
  card_005,
  card_006,
  card_007,
  card_008,
  card_009,
  card_010,
  card_012,
  card_013,
  card_014,
  card_015,
  card_016,
  card_017,
  card_018,
  card_019,
  card_020,
  card_021,
  card_022,
  card_023,
  card_024,
  card_025,
  card_026,
  card_027,
};

export default cards;
